export default "__VITE_ASSET__C0n_Ezjv__"